import React from 'react'
import styles from '@bt-react/styles'
import componentStyle from './VotesPercentageBox.module.scss'
import { PercentageBoxProps } from './../types'

const PercentageBox: React.FC<PercentageBoxProps> = ({ percentage }) =>

  <div className={ componentStyle['percentage-box-container']} data-bdd="percentage-box-container">
    <div className={`${styles['font-weight-bold']} ${styles['p-0']}`}>
      <div className={`${componentStyle['percentage-text']}`}>
        { percentage }%
      </div>
    </div>
  </div>

export default PercentageBox
